import React, { useEffect, useState } from "react";
import { Megaphone, Loader2, FileText, Image as ImageIcon, Clock } from "lucide-react";
import empApi from "../../lib/empApi";

const API = process.env.REACT_APP_BACKEND_URL;
const fileUrl = (u) => (u && u.startsWith("http") ? u : `${API}${u}`);

function fmt(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }); } catch { return ""; }
}

export default function EmpAnnouncements() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    empApi.get("/employee/announcements").then(({ data }) => {
      setItems(data.announcements || []);
      // mark unread as read
      (data.announcements || []).filter((a) => !a.read).forEach((a) =>
        empApi.post(`/employee/notifications/${a.id}/read`).catch(() => {}));
    }).catch(() => setItems([]));
  }, []);

  if (!items) return <div className="flex h-64 items-center justify-center"><Loader2 className="animate-spin text-amber-400" /></div>;

  return (
    <div className="space-y-4" data-testid="emp-announcements-page">
      <div className="flex items-center gap-2"><Megaphone size={20} className="text-amber-400" /><h2 className="font-heading text-xl font-bold text-white">Pengumuman HRD</h2></div>

      {items.length === 0 ? (
        <p className="py-10 text-center text-sm text-slate-500" data-testid="emp-ann-empty">Belum ada pengumuman aktif.</p>
      ) : (
        <div className="space-y-3" data-testid="emp-ann-list">
          {items.map((a) => (
            <div key={a.id} className="rounded-2xl border border-slate-800 bg-slate-800/40 p-4" data-testid={`emp-ann-${a.id}`}>
              <div className="mb-1 flex items-start justify-between gap-3">
                <h3 className="font-heading text-base font-bold text-white">{a.title}</h3>
                <span className="flex shrink-0 items-center gap-1 text-[10px] text-slate-500"><Clock size={11} /> {fmt(a.created_at)}</span>
              </div>
              {a.image_url && (
                <img src={fileUrl(a.image_url)} alt="" className="my-2 max-h-60 w-full rounded-xl object-cover" data-testid={`emp-ann-img-${a.id}`} />
              )}
              <div className="prose-invert text-sm leading-relaxed text-slate-300 [&_b]:text-white [&_li]:ml-4 [&_li]:list-disc"
                   dangerouslySetInnerHTML={{ __html: a.body_html || "" }} />
              {a.attachment_url && (
                <a href={fileUrl(a.attachment_url)} target="_blank" rel="noreferrer" data-testid={`emp-ann-file-${a.id}`}
                  className="mt-3 inline-flex items-center gap-2 rounded-lg border border-slate-700 bg-slate-900/60 px-3 py-2 text-xs font-semibold text-amber-300">
                  <FileText size={14} /> {a.attachment_name || "Lampiran"}
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
